module.exports = __webpack_public_path__ + "static/media/media.317c4130.png";